// Utility functions cho các components
export const getSaturationColor = (score) => {
  // Return translation keys instead of hardcoded text
  if (score >= 70) return { color: '#d32f2f', bg: '#ffebee', textKey: 'saturation.saturationLevel.extreme', text: 'Extreme' };
  if (score >= 50) return { color: '#f57c00', bg: '#fff3e0', textKey: 'saturation.saturationLevel.high', text: 'High' };
  if (score >= 30) return { color: '#fbc02d', bg: '#fffde7', textKey: 'saturation.saturationLevel.moderate', text: 'Moderate' };
  return { color: '#388e3c', bg: '#e8f5e9', textKey: 'saturation.saturationLevel.low', text: 'Low' };
};

export const getRecommendation = (score) => {
  if (score >= 70) return { textKey: 'saturation.sectorDetail.avoidReduce', text: 'Avoid / Reduce', severity: 'error' };
  if (score >= 50) return { textKey: 'saturation.sectorDetail.cautionMonitor', text: 'Caution / Monitor', severity: 'warning' };
  if (score >= 30) return { textKey: 'saturation.sectorDetail.selectiveWatch', text: 'Selective / Watch', severity: 'info' };
  return { textKey: 'saturation.sectorDetail.attractiveAccumulate', text: 'Attractive / Accumulate', severity: 'success' };
};